import * as React from 'react';
import styled from '@emotion/styled';
import { useFormik } from 'formik';
import { AbstractGroupType, Pack } from '@foxbun/lib-goferal-types';
import { InputContainerWidget } from '../../../widgets/forms/InputContainerWidget';
import { TextInputType, TextInputWidget } from '../../../widgets/forms/TextInputWidget';
import { SelectInputWidget } from '../../../widgets/forms/SelectInputWidget';
import { ButtonWidget } from '../../../widgets/controls/ButtonWidget';
import { useSystem } from '../../../hooks/useSystem';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';

export const CreatePackPage: React.FC = observer(() => {
  const system = useSystem();
  const navigate = useNavigate();
  const { errors, getFieldHelpers, values, isValid, isSubmitting, submitForm } = useFormik<Pack>({
    initialValues: {
      name: '',
      about: '',
      public: true,
      custom_roles: [],
      type: AbstractGroupType.PACK
    },
    onSubmit: async (pack) => {
      await system.session.api_client.packs.createPack(pack);
      navigate(-1);
    }
  });
  return (
    <S.Container>
      <InputContainerWidget label="Pack Name" error={errors.name}>
        <TextInputWidget type={TextInputType.TEXT} value={values.name} onChange={getFieldHelpers('name').setValue} />
      </InputContainerWidget>
      <InputContainerWidget label="About" error={errors.about}>
        <TextInputWidget
          type={TextInputType.PARAGRAPH}
          value={values.about}
          onChange={getFieldHelpers('about').setValue}
        />
      </InputContainerWidget>
      <InputContainerWidget label="Pack type">
        <SelectInputWidget
          value={values.public ? 'public' : 'private'}
          onChange={(key) => {
            getFieldHelpers('public').setValue(key === 'public');
          }}
          options={[
            {
              key: 'public',
              title: 'Public'
            },
            {
              key: 'private',
              title: 'Private'
            }
          ]}
        />
      </InputContainerWidget>
      <ButtonWidget
        disabled={!isValid}
        loading={isSubmitting}
        label="Create pack"
        action={() => {
          submitForm();
        }}
      />
    </S.Container>
  );
});
namespace S {
  export const Container = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
  `;
}
